export default __webpack_public_path__ + "images/f284ac59591ccd19626f0f0e916461c1.png";